import { lazy } from 'react';

import { DOTLOTTIE_ASSET_VERSION } from './dotlottie-assets.generated';

// Lazy-load the dotLottie player so @lottiefiles/dotlottie-react (and its ~84 KiB
// JS + WASM decoder) stays out of the shared entry chunk (#412). Every component
// that renders a Lottie animation uses this wrapper instead of importing
// DotLottieReact directly, so dotlottie is only fetched when an animation is
// actually shown. The WASM decoder and the worker are pointed at our
// self-hosted copies so neither is fetched from jsDelivr/unpkg (blocked by the
// production CSP). public/wasm/ is kept in sync with the installed
// dotlottie-web version by scripts/copy-dotlottie-assets.ts (runs in build).
//
// Importing this module is free — the player module loads on first render of a
// <DotLottiePlayer>, and all props are forwarded to DotLottieReact unchanged.
export const DotLottiePlayer = lazy(async () => {
  const mod = await import('@lottiefiles/dotlottie-react');
  try {
    // setWasmUrl/setWorkerUrl are real exports of @lottiefiles/dotlottie-react;
    // the guard is for unit tests that mock the package without exposing them.
    // Filenames are versioned (see scripts/copy-dotlottie-assets.ts) because the
    // wasm is immutable-cached for 30 days; a same-URL bump would leave users
    // on a decoder that mismatches the JS runtime.
    mod.setWasmUrl(`/wasm/dotlottie-player-${DOTLOTTIE_ASSET_VERSION}.wasm`);
    mod.setWorkerUrl(`/wasm/dotlottie.worker-${DOTLOTTIE_ASSET_VERSION}.js`);
  } catch {
    // Mocked module without setWasmUrl (test environment) — nothing to configure.
  }
  return { default: mod.DotLottieReact };
});
